import { apiFetch } from '../utils/api';

export interface ProductVariantValue {
  id: string;
  erpId: number;
  attributeErpId: number;
  value: string;
  attribute?: {
    id: string;
    name: string;
    erpId: number;
  } | null;
}

export interface ProductVariant {
  id: string;
  erpId: number;
  name: string;
  variantCode?: string | null;
  retailPrice: string | null;
  currencyCode: string | null;
  brand?: { id: string; name: string | null; erpId: number | null } | null;
  masterProductErpId: number | null;
  companyErpId: number | null;
  vendorErpId: number | null;
  articleNumber: string | null;
  upc: string | null;
  originalCreatedAt: string | null;
  isVariantEnabled: boolean;
  isCreatedByWorkshopManagement: boolean;
  isActive: boolean;
  values?: ProductVariantValue[];
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedVariantsResponse {
  data: ProductVariant[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const fetchProductVariants = (params: {
  page?: number;
  limit?: number;
  search?: string;
  createdByWorkshopManagement?: boolean;
  vehicleBrandId?: string;
  vehicleModelId?: string;
  isActive?: boolean;
} = {}): Promise<PaginatedVariantsResponse> => {
  const searchParams = new URLSearchParams();

  if (params.page) {
    searchParams.set('page', String(params.page));
  }

  if (params.limit) {
    searchParams.set('limit', String(params.limit));
  }

  if (params.search) {
    searchParams.set('search', params.search);
  }

  if (params.createdByWorkshopManagement !== undefined) {
    searchParams.set('createdByWorkshopManagement', String(params.createdByWorkshopManagement));
  }

  if (params.isActive !== undefined) {
    searchParams.set('isActive', String(params.isActive));
  }

  if (params.vehicleBrandId) {
    searchParams.set('vehicleBrandId', params.vehicleBrandId);
  }

  if (params.vehicleModelId) {
    searchParams.set('vehicleModelId', params.vehicleModelId);
  }

  const query = searchParams.toString();
  return apiFetch<PaginatedVariantsResponse>(
    `/product/variants${query ? `?${query}` : ''}`,
  );
};

export const fetchProductVariant = (id: string) =>
  apiFetch<ProductVariant>(`/product/variants/${id}`);

export const updateProductVariantActive = (id: string, isActive: boolean) =>
  apiFetch<ProductVariant>(`/product/variants/${id}/active`, {
    method: 'PUT',
    body: JSON.stringify({ isActive }),
  });

export const removeProductVariant = (id: string): Promise<{ success: boolean }> =>
  apiFetch<{ success: boolean }>(`/product/variants/${id}`, {
    method: 'DELETE',
  });
